export enum STATS_TABS {
  OVERVIEW = 'overview',
  OVERVIEW_BETA = 'overview_beta',
  ANALYTICS = 'analytics',
  ANALYTICS_PLUS = 'analytics_plus',
  MONITORING = 'monitoring',
  AVAILABILITIES = 'availabilities',
}
